(ns practitest.frontend.components2.dashboard.charts.vega
  (:require [practitest.frontend.components2.dashboard.charts.render :as render]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]))

(defmethod p/render! ::chart/vega [chart _ctx svg-el]
  (render/render-chart! svg-el chart))
